import { isApiEnabled } from "../api/config";
import { supportApi, type SupportChatResponse, type SupportMessageDto } from "../api/support";
import { formatApiError } from "../api/client";

export type { SupportMessageDto, SupportChatResponse };

const LOCAL_TOPICS = [
  "Заезд и монтаж",
  "Документы и пропуска",
  "Техуслуги и стенд",
  "Связь с менеджером",
];

export const supportService = {
  async getChat(eventId: string): Promise<SupportChatResponse> {
    if (!isApiEnabled()) {
      return {
        sessionId: "local",
        messages: [
          {
            id: 1,
            role: "assistant",
            content:
              "Здравствуйте! Я ИИ-помощник выставки. В демо-режиме ответы из базы знаний недоступны — включите API.",
            createdAt: new Date().toISOString(),
          },
        ],
        reply: {
          id: 1,
          role: "assistant",
          content: "",
          createdAt: new Date().toISOString(),
        },
        escalated: false,
        topics: LOCAL_TOPICS,
      };
    }
    try {
      return await supportApi.getChat(eventId);
    } catch (err) {
      throw new Error(formatApiError(err, "Не удалось открыть чат поддержки"));
    }
  },

  async sendMessage(eventId: string, message: string): Promise<SupportChatResponse> {
    if (!isApiEnabled()) {
      throw new Error("API отключён");
    }
    try {
      return await supportApi.sendMessage(eventId, message);
    } catch (err) {
      throw new Error(formatApiError(err, "Не удалось отправить сообщение"));
    }
  },

  /** Fire-and-forget: remember exhibition for MAX DM answers */
  syncContext(eventId: string): void {
    if (!isApiEnabled() || !eventId) return;
    void supportApi.setContext(eventId).catch(() => undefined);
  },
};
